let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6s7py")).then(() => parcelRequire('hd4f0'));